import apiPrivate from "./apiPrivate.service";

const API_URL = "/payments";

class PaymentService {
    async createCheckoutSession(amount, legalConsent) {
        try {
            const response = await apiPrivate.post(`${API_URL}/checkout-session`, {
                amount,
                ...legalConsent
            });
            return response.data;
        } catch (error) {
            console.error("Erreur lors de la création de la session Stripe :", error);
            throw error;
        }
    }

    async confirmCheckoutSession(sessionId) {
        try {
            const response = await apiPrivate.post(`${API_URL}/checkout-session/${sessionId}/confirm`);
            return response.data;
        } catch (error) {
            console.error("Erreur lors de la confirmation de la session Stripe :", error);
            throw error;
        }
    }
}

export default new PaymentService();
